// ==================== User & Auth ====================

export type UserRoleType = "admin" | "region" | "district" | "hall";

export enum UserRole {
	ADMIN = 100,
	REGION = 200,
	DISTRICT = 300,
	HALL = 400,
}

export interface User {
	id: number;
	name: string;
	username: string;
	phone: string;
	role: {
		id: number;
		name: string;
	} | null;
	region_id: number | null;
	district_id: number | null;
	image: string;
	created?: string;
}

// ==================== API Response ====================

export interface ApiResponse<T> {
	success: boolean;
	message?: string;
	data: T;
}

export interface ApiError {
	success: false;
	error: {
		code: string;
		message: string;
		details?: Record<string, string>;
	};
}

export type SuccessResponse<T> = ApiResponse<T>;
export type ErrorResponse = ApiError;

export function isSuccessResponse<T>(
	response: ApiResponse<T> | ApiError,
): response is ApiResponse<T> {
	return response.success === true;
}

export function isErrorResponse(
	response: ApiResponse<unknown> | ApiError,
): response is ApiError {
	return response.success === false;
}

// ==================== Auth ====================

export interface LoginRequest {
	username: string;
	password: string;
}

export interface LoginData {
	user: User;
	token: string;
}

export type LoginResponse = ApiResponse<LoginData>;

export interface AuthData {
	user: User;
	token: string;
}

export type AuthTokens = { token: string };

export type MeResponse = ApiResponse<User>;

export type LogoutRequest = Record<string, never>;
export type LogoutResponse = ApiResponse<null>;

// refresh token yo'q — kerak emas
export type RefreshTokenRequest = never;
export type RefreshResponse = never;

// ==================== Pagination ====================

export interface Pagination {
	current_page: number;
	per_page: number;
	total_items: number;
	total_pages: number;
	has_next: boolean;
	has_prev: boolean;
}

export interface PaginatedResponse<T> {
	items: T[];
	pagination: Pagination;
}
